import { Volume2, VolumeX } from "lucide-react";

export default function VolumeControl({ volume, onChange }) {
  const muted = volume === 0;

  return (
    <div
      data-testid="volume-control"
      className="flex items-center gap-3 rounded-full bg-white/60 border border-sky-200 backdrop-blur-md px-5 py-2.5 opacity-90 hover:opacity-100 transition-opacity duration-300"
    >
      <button
        data-testid="mute-button"
        aria-label={muted ? "Riattiva il volume" : "Silenzia"}
        onClick={() => onChange(muted ? 0.85 : 0)}
        className="text-sky-700 hover:text-sky-500 transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/60 rounded-full p-1"
      >
        {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
      </button>
      <input
        data-testid="volume-slider"
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        aria-label="Volume"
        className="nl-slider w-36 sm:w-48"
      />
    </div>
  );
}
